export default __webpack_public_path__ + "static/media/DSC_6112-min.1f37319e.JPG";